module.exports = [
  {
    id: "insuranceLeadOwner",
    fieldName: "Insurance Lead Owner",
  },
  {
    id: "lastName",
    fieldName: "Last Name",
  },
];
